module.exports = __webpack_public_path__ + "img/logo_entretantocuento.0f815bb8.png";